(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		// smart 在吸附上和 always 完全一样（整块页头一直钉住），只多一件事：导航行跟随滚动方向收起/放出
		this.isSmart = this.getAttribute('data-sticky-type') === 'smart';
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.isSmart;
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		if (this.isSmart) this.setupSmartNav();
		this.createObserver();
	}

	setupSmartNav() {
		this.smartNav = this.querySelector('.header__inline-menu');
		if (!this.header || !this.smartNav) return;
		this.header.classList.add('shopify-section-header--smart');
		this.smartLastTop = window.scrollY;
		// 页头自然位置的底边：滚过它之前导航行永远展开（顶部区域不做收起）
		this.smartTopLimit = this.header.getBoundingClientRect().bottom + window.scrollY;

		// 鼠标靠近页头时放出导航（只对鼠标；触屏和键盘照旧靠上滑 / Tab）。
		// 做法同 macOS 全屏菜单栏、Headroom 一类：进入品牌行（+8px）停留 120ms 才展开，路过去点搜索/购物车不会误触；
		// 离开导航下沿 24px 外 300ms 才收回，指针在边缘抖动不会来回闪。只收回由指针放出来的那次，上滑放出的不管。
		this.smartPointerQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
		this.smartPointerOpened = false;
		this.smartPointerFrame = 0;
		this.onSmartPointerMove = event => {
			if (event.pointerType !== 'mouse' || this.smartPointerFrame) return;
			const y = event.clientY;
			this.smartPointerFrame = requestAnimationFrame(() => {
				this.smartPointerFrame = 0;
				this.onSmartPointer(y);
			});
		};
		document.addEventListener('pointermove', this.onSmartPointerMove, { passive: true });
	}

	onSmartPointer(y) {
		const stuck = this.header.classList.contains('shopify-section-header-sticky');
		if (!stuck || !this.smartPointerQuery.matches || this.smartNav.offsetParent === null) {
			this.clearSmartPointerTimer();
			return;
		}
		const brand = this.header.querySelector('.menuTopBox');
		const brandBottom = brand ? brand.getBoundingClientRect().bottom : 0;
		const collapsed = this.header.classList.contains('header--nav-collapsed');
		if (collapsed) {
			if (y <= brandBottom + 8) {
				this.scheduleSmartPointer('open', 120, () => {
					this.setNavCollapsed(false);
					this.smartPointerOpened = true;
				});
			} else {
				this.clearSmartPointerTimer();
			}
			return;
		}
		if (!this.smartPointerOpened) return;
		const navBottom = this.smartNav.getBoundingClientRect().bottom;
		if (y > navBottom + 24) {
			this.scheduleSmartPointer('close', 300, () => {
				// 键盘焦点在导航里、或下拉菜单开着时不收
				if (this.smartNav.matches(':hover, :focus-within')) return;
				if ((window.pageYOffset || document.documentElement.scrollTop) <= this.smartTopLimit) return;
				this.setNavCollapsed(true);
			});
		} else {
			this.clearSmartPointerTimer();
		}
	}

	// 同一种动作（open / close）已在计时就不重排，指针每帧移动不会把延时一直往后推
	scheduleSmartPointer(kind, delay, run) {
		if (this.smartPointerTimer && this.smartPointerKind === kind) return;
		this.clearSmartPointerTimer();
		this.smartPointerKind = kind;
		this.smartPointerTimer = setTimeout(() => {
			this.smartPointerTimer = 0;
			this.smartPointerKind = '';
			run();
		}, delay);
	}

	clearSmartPointerTimer() {
		if (this.smartPointerTimer) clearTimeout(this.smartPointerTimer);
		this.smartPointerTimer = 0;
		this.smartPointerKind = '';
	}

	onSmartScroll(scrollTop) {
		// <1200px 没有导航行（走汉堡抽屉），没东西可收
		if (!this.smartNav || this.smartNav.offsetParent === null) {
			this.setNavCollapsed(false);
			this.smartLastTop = scrollTop;
			return;
		}
		if (scrollTop <= this.smartTopLimit) {
			this.setNavCollapsed(false);
			this.smartLastTop = scrollTop;
			return;
		}
		const delta = scrollTop - this.smartLastTop;
		// 触控板/惯性滚动会来回抖几个像素，攒够 8px 才算换了方向
		if (Math.abs(delta) < 8) return;
		this.smartLastTop = scrollTop;
		if (delta < 0) {
			this.setNavCollapsed(false);
			return;
		}
		// 鼠标正停在导航上、键盘焦点在导航里、或下拉菜单开着时不收，免得菜单在手底下消失
		if (this.smartNav.matches(':hover, :focus-within')) return;
		this.setNavCollapsed(true);
	}

	setNavCollapsed(collapsed) {
		// 任何一次状态变化（滚动或指针）都作废还没到点的指针动作；只有指针放出的那次之后才标记 smartPointerOpened
		this.smartPointerOpened = false;
		this.clearSmartPointerTimer();
		if (!this.header || this.header.classList.contains('header--nav-collapsed') === collapsed) return;
		this.header.classList.toggle('header--nav-collapsed', collapsed);
		if (collapsed) this.closeMenuDisclosure();
		// 吸顶的筛选栏 / PDP 信息栏按 --header-height 贴在页头下面，跟着可见高度更新
		if (typeof calcHeader === 'function') calcHeader();
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
		// 主题编辑器重画页头时卸掉旧实例的指针监听和计时
		if (this.onSmartPointerMove) document.removeEventListener('pointermove', this.onSmartPointerMove);
		if (this.smartPointerFrame) cancelAnimationFrame(this.smartPointerFrame);
		this.clearSmartPointerTimer && this.clearSmartPointerTimer();
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.isSmart) this.onSmartScroll(scrollTop);

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
		this.header.style.transform = 'translateY(-100%)';
	};

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
		this.header.classList.remove('color-background-2');
		this.header.style.transition = 'background var(--duration-short)';
		this.header.style.transform = 'translateY(0)';
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
		this.header.style.transform = 'translateY(0)';
		this.header.style.transition = 'background var(--duration-short)';
		if (this.header.classList.contains('color-background-1')) {
		this.header.classList.add('color-background-2');
		};
	};

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;
		if (document.querySelector(".overflow-hidden-tablet")) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		if (document.querySelector('.entering-section')) {
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
		}
		else{
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden','color-background-2');
		}
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		if (this.header.classList.contains('color-background-1')) {
			this.header.classList.add('color-background-2');
		};
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close();
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true);
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items-hulkapps-backup"]) return;
  try {
    
  //class CartNote extends HTMLElement {
  //  constructor() {
  //    super();

  //    this.addEventListener(
  //      'change',
  //      debounce((event) => {
  //        const body = JSON.stringify({ note: event.target.value });
  //        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
  //      }, 300)
  //    );
  //  }
  //}

  //customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  //class CartNote extends HTMLElement {
  //  constructor() {
  //    super();

  //    this.addEventListener(
  //      'change',
  //      debounce((event) => {
  //        const body = JSON.stringify({ note: event.target.value });
  //        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
  //      }, 300)
  //    );
  //  }
  //}

  //customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();

      this.isProductPage = true;
    }

    hide() {
      super.hide(this.isProductPage);
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      if (activeMedia) {
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
      }
      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
